import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocationService } from 'src/app/services/location/location.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.sass'],
})
export class FaqComponent implements OnInit {
  isEditMode = false;
  data;

  prevData;
  answerChanged = false;
  dataServiceSub: Subscription;
  currLoc;
  unsubber: Subject<boolean> = new Subject<boolean>();

  constructor(
    private spinner: NgxSpinnerService,
    private locationService: LocationService,
    private locationStore: LocationStoreService
  ) {}

  ngOnInit(): void {
    this.prevData = JSON.stringify(this.data);
    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (res.id) {
          this.currLoc = res;
          if (res.faq?.length > 0) {
            this.data = [...JSON.parse(res.faq)];
            console.log(res.faq);
          } else {
            this.data = [
              {
                question: 'Example question with inline layout (1):',
                question_type: 'text',
                answer: ['Your answer'],
                answer_checkbox: [],
                question_display_template: 'inline',
              },
              {
                question: 'Example question with row layout (2):',
                question_type: 'text',
                answer: ['Your another answer'],
                answer_checkbox: [],
                question_display_template: 'row',
              },
              {
                question: 'Example multiple answer question (3):',
                question_type: 'checkbox',
                answer: ['0', '1'],
                answer_checkbox: ['Option 1', 'Option 2', 'Option 3'],
                question_display_template: 'row',
              },
              {
                question: 'Example single answer question (4):',
                question_type: 'radio',
                answer: ['1'],
                answer_checkbox: ['Yes', 'No', 'Maybe'],
                question_display_template: 'row',
              },
            ];
          }
        }
      });
  }

  ngOnDestroy() {
    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
  }

  onEditQuestion() {
    this.isEditMode = true;
    this.prevData = JSON.stringify(this.data);
  }

  addMoreQuestion() {
    this.data.push({
      question: 'Please enter the question',
      question_type: 'text',
      answer: [''],
      answer_checkbox: [''],
      question_display_template: 'row',
    });
  }

  deleteQuestion(key) {
    this.data.splice(key, 1);
  }

  onChangeAnswer(event) {
    event.preventDefault();
    const { value, name } = event.target;

    const idx = name.split('-')[1];

    switch (this.data[idx].question_type) {
      case 'checkbox':
        if (this.data[idx].answer.includes(value)) {
          let pos = this.data[idx].answer.indexOf(value);
          if (pos > -1) {
            this.data[idx].answer.splice(pos, 1);
          }
        } else this.data[idx].answer.push(value);
        break;

      default:
        this.data[idx].answer = [value];
        break;
    }

    this.answerChanged =
      JSON.stringify(this.data).localeCompare(this.prevData) === 0
        ? false
        : true;
  }

  onChangeQuestion(event) {
    event.preventDefault();
    const { value, name } = event.target;

    const key = name.split('-');
    switch (key[0]) {
      case 'question':
        this.data[key[1]].question = value;
        break;
      case 'question_display_template':
        this.data[key[1]].question_display_template = value;
        break;
      case 'question_type':
        this.data[key[1]].question_type = value;
        if (value !== 'text') {
          this.data[key[1]].answer_checkbox.push('');
        } else {
          this.data[key[1]].answer_checkbox = [];
        }
        break;
      case 'answer_checbox':
        this.data[key[1]].answer_checkbox[key[2]] = value;
        break;

      default:
        break;
    }
  }

  addAnswerCheckbox(key) {
    this.data[key].answer_checkbox.push('');
  }

  removeAnswerCheckbox(qkey, key) {
    this.data[qkey].answer.splice(key, 1);
  }

  onCancel() {
    // console.log(JSON.stringify(this.data).localeCompare(this.prevData));
    this.data = JSON.parse(this.prevData);
    this.isEditMode = false;
  }

  onSaveQuestion() {
    this.spinner.show();
    this.locationService
      .updateFaq(this.currLoc.id, { faq: JSON.stringify(this.data) })
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.prevData = JSON.stringify(this.data);
        this.spinner.hide();
        this.isEditMode = false;
      });
  }

  onSaveAnswer() {
    this.spinner.show();
    this.locationService
      .updateFaq(this.currLoc.id, { faq: JSON.stringify(this.data) })
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        this.prevData = JSON.stringify(this.data);
        this.answerChanged = false;
        this.locationStore.setLocations({ ...this.currLoc, faq: res.faq });
        this.spinner.hide();
      });
  }
}
